import React, { Suspense } from "react";
import { updateActiveUserTime } from "../../custom_functions/Functions.jsx";
const FileView = React.lazy(() => import("../FileView.jsx"));

class PFileViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileobj: this.props.location.params !== undefined ? this.props.location.params  : sessionStorage.fileobj,
    };
  }
  componentDidMount() {
    sessionStorage.setItem("_OrderView", "1");
    updateActiveUserTime();
  }
  render() {
    //  if (!$.session.get("User")) {
    //   setTimeout(() => {
    //     let tenantdomain= $.session.get("tenantdomain");

    //     if(tenantdomain !== undefined){
    //             isMultitenant === 0
    //             ? this.props.history.push("/")
    //             : this.props.history.push("/#" + tenantdomain);

    //           }else{
    //             this.props.history.push("/")
    //           }
    //   }, 100);
    //   return <div></div>;
    // }
    return (
      <Suspense fallback={<div></div>}>
        <FileView values={this.state.fileobj} />
      </Suspense>
    );
  }
}
export default PFileViewer;
